module.exports = __webpack_public_path__ + "downloadimg-55fcb5bb.png";